function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
import { AbortController } from '@uppy/utils/lib/AbortController';
var MB = 1024 * 1024;
var defaultOptions = {
  getChunkSize: function getChunkSize(file) {
    return Math.ceil(file.size / 10000);
  },
  onProgress: function onProgress() {},
  onPartComplete: function onPartComplete() {},
  onSuccess: function onSuccess() {},
  onError: function onError(err) {
    throw err;
  }
};
function ensureInt(value) {
  if (typeof value === 'string') {
    // @ts-expect-error TS is not able to recognize it's fine.
    return parseInt(value, 10);
  }
  if (typeof value === 'number') {
    // @ts-expect-error TS is not able to recognize it's fine.
    return value;
  }
  throw new TypeError('Expected a number');
}
export var pausingUploadReason = Symbol('pausing upload, not an actual error');

/**
 * A MultipartUploader instance is used per file upload to determine whether a
 * upload should be done as multipart or as a regular S3 upload
 * (based on the user-provided `shouldUseMultipart` option value) and to manage
 * the chunk splitting.
 */
var _abortController = /*#__PURE__*/_classPrivateFieldLooseKey("abortController");
var _chunks = /*#__PURE__*/_classPrivateFieldLooseKey("chunks");
var _chunkState = /*#__PURE__*/_classPrivateFieldLooseKey("chunkState");
var _data = /*#__PURE__*/_classPrivateFieldLooseKey("data");
var _file = /*#__PURE__*/_classPrivateFieldLooseKey("file");
var _uploadHasStarted = /*#__PURE__*/_classPrivateFieldLooseKey("uploadHasStarted");
var _onError = /*#__PURE__*/_classPrivateFieldLooseKey("onError");
var _onSuccess = /*#__PURE__*/_classPrivateFieldLooseKey("onSuccess");
var _shouldUseMultipart = /*#__PURE__*/_classPrivateFieldLooseKey("shouldUseMultipart");
var _isRestoring = /*#__PURE__*/_classPrivateFieldLooseKey("isRestoring");
var _onReject = /*#__PURE__*/_classPrivateFieldLooseKey("onReject");
var _maxMultipartParts = /*#__PURE__*/_classPrivateFieldLooseKey("maxMultipartParts");
var _minPartSize = /*#__PURE__*/_classPrivateFieldLooseKey("minPartSize");
var _initChunks = /*#__PURE__*/_classPrivateFieldLooseKey("initChunks");
var _createUpload = /*#__PURE__*/_classPrivateFieldLooseKey("createUpload");
var _resumeUpload = /*#__PURE__*/_classPrivateFieldLooseKey("resumeUpload");
var _onPartProgress = /*#__PURE__*/_classPrivateFieldLooseKey("onPartProgress");
var _onPartComplete = /*#__PURE__*/_classPrivateFieldLooseKey("onPartComplete");
var _abortUpload = /*#__PURE__*/_classPrivateFieldLooseKey("abortUpload");
var MultipartUploader = /*#__PURE__*/function () {
  function MultipartUploader(data, options) {
    var _this = this;
    _classCallCheck(this, MultipartUploader);
    var _this$options, _this$options$getChun;
    Object.defineProperty(this, _abortUpload, {
      value: _abortUpload2
    });
    Object.defineProperty(this, _resumeUpload, {
      value: _resumeUpload2
    });
    Object.defineProperty(this, _createUpload, {
      value: _createUpload2
    });
    // initChunks checks the user preference for using multipart uploads (opts.shouldUseMultipart)
    // and calculates the optimal part size. When using multipart part uploads every part except for the last has
    // to be at least 5 MB and there can be no more than 10K parts.
    // This means we sometimes need to change the preferred part size from the user in order to meet these requirements.
    Object.defineProperty(this, _initChunks, {
      value: _initChunks2
    });
    Object.defineProperty(this, _abortController, {
      writable: true,
      value: new AbortController()
    });
    Object.defineProperty(this, _chunks, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _chunkState, {
      writable: true,
      value: void 0
    });
    /**
     * The (un-chunked) data to upload.
     */
    Object.defineProperty(this, _data, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _file, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _uploadHasStarted, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _onError, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _onSuccess, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _shouldUseMultipart, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _isRestoring, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _onReject, {
      writable: true,
      value: function value(err) {
        return (err == null ? void 0 : err.cause) === pausingUploadReason ? null : _classPrivateFieldLooseBase(_this, _onError)[_onError](err);
      }
    });
    Object.defineProperty(this, _maxMultipartParts, {
      writable: true,
      value: 10000
    });
    Object.defineProperty(this, _minPartSize, {
      writable: true,
      value: 5 * MB
    });
    Object.defineProperty(this, _onPartProgress, {
      writable: true,
      value: function value(index) {
        return function (ev) {
          if (!ev.lengthComputable) return;
          _classPrivateFieldLooseBase(_this, _chunkState)[_chunkState][index].uploaded = ensureInt(ev.loaded);
          var totalUploaded = _classPrivateFieldLooseBase(_this, _chunkState)[_chunkState].reduce(function (n, c) {
            return n + c.uploaded;
          }, 0);
          _this.options.onProgress(totalUploaded, _classPrivateFieldLooseBase(_this, _data)[_data].size);
        };
      }
    });
    Object.defineProperty(this, _onPartComplete, {
      writable: true,
      value: function value(index) {
        return function (etag) {
          // This avoids the net::ERR_OUT_OF_MEMORY in Chromium Browsers.
          _classPrivateFieldLooseBase(_this, _chunks)[_chunks][index] = null;
          _classPrivateFieldLooseBase(_this, _chunkState)[_chunkState][index].etag = etag;
          _classPrivateFieldLooseBase(_this, _chunkState)[_chunkState][index].done = true;
          var part = {
            PartNumber: index + 1,
            ETag: etag
          };
          _this.options.onPartComplete(part);
        };
      }
    });
    this.options = _objectSpread(_objectSpread({}, defaultOptions), options);
    // Use default `getChunkSize` if it was null or something
    (_this$options$getChun = (_this$options = this.options).getChunkSize) != null ? _this$options$getChun : _this$options.getChunkSize = defaultOptions.getChunkSize;
    _classPrivateFieldLooseBase(this, _data)[_data] = data;
    _classPrivateFieldLooseBase(this, _file)[_file] = options.file;
    _classPrivateFieldLooseBase(this, _onSuccess)[_onSuccess] = this.options.onSuccess;
    _classPrivateFieldLooseBase(this, _onError)[_onError] = this.options.onError;
    _classPrivateFieldLooseBase(this, _shouldUseMultipart)[_shouldUseMultipart] = this.options.shouldUseMultipart;

    // When we are restoring an upload, we already have an UploadId and a Key. Otherwise
    // we need to call `createMultipartUpload` to get an `uploadId` and a `key`.
    // Non-multipart uploads are not restorable.
    _classPrivateFieldLooseBase(this, _isRestoring)[_isRestoring] = options.uploadId && options.key;
    _classPrivateFieldLooseBase(this, _initChunks)[_initChunks]();
  }
  _createClass(MultipartUploader, [{
    key: "start",
    value: function start() {
      if (_classPrivateFieldLooseBase(this, _uploadHasStarted)[_uploadHasStarted]) {
        if (!_classPrivateFieldLooseBase(this, _abortController)[_abortController].signal.aborted) _classPrivateFieldLooseBase(this, _abortController)[_abortController].abort(pausingUploadReason);
        _classPrivateFieldLooseBase(this, _abortController)[_abortController] = new AbortController();
        _classPrivateFieldLooseBase(this, _resumeUpload)[_resumeUpload]();
      } else if (_classPrivateFieldLooseBase(this, _isRestoring)[_isRestoring]) {
        this.options.companionComm.restoreUploadFile(_classPrivateFieldLooseBase(this, _file)[_file], {
          uploadId: this.options.uploadId,
          key: this.options.key
        });
        _classPrivateFieldLooseBase(this, _resumeUpload)[_resumeUpload]();
      } else {
        _classPrivateFieldLooseBase(this, _createUpload)[_createUpload]();
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      _classPrivateFieldLooseBase(this, _abortController)[_abortController].abort(pausingUploadReason);
      // Swap it out for a new controller, because this instance may be resumed later.
      _classPrivateFieldLooseBase(this, _abortController)[_abortController] = new AbortController();
    }
  }, {
    key: "abort",
    value: function abort(opts) {
      if (opts != null && opts.really) _classPrivateFieldLooseBase(this, _abortUpload)[_abortUpload]();else this.pause();
    }

    // TODO: remove this in the next major
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  }, {
    key: "chunkState",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _chunkState)[_chunkState];
    }
  }]);
  return MultipartUploader;
}();
function _initChunks2() {
  var _this2 = this;
  var fileSize = _classPrivateFieldLooseBase(this, _data)[_data].size;
  var shouldUseMultipart = typeof _classPrivateFieldLooseBase(this, _shouldUseMultipart)[_shouldUseMultipart] === 'function' ? _classPrivateFieldLooseBase(this, _shouldUseMultipart)[_shouldUseMultipart](_classPrivateFieldLooseBase(this, _file)[_file]) : Boolean(_classPrivateFieldLooseBase(this, _shouldUseMultipart)[_shouldUseMultipart]);
  if (shouldUseMultipart && fileSize > _classPrivateFieldLooseBase(this, _minPartSize)[_minPartSize]) {
    // At least 5MB per request:
    var chunkSize = Math.max(this.options.getChunkSize(_classPrivateFieldLooseBase(this, _data)[_data]), _classPrivateFieldLooseBase(this, _minPartSize)[_minPartSize]);
    var arraySize = Math.floor(fileSize / chunkSize);

    // At most 10k requests per file:
    if (arraySize > _classPrivateFieldLooseBase(this, _maxMultipartParts)[_maxMultipartParts]) {
      arraySize = _classPrivateFieldLooseBase(this, _maxMultipartParts)[_maxMultipartParts];
      chunkSize = fileSize / _classPrivateFieldLooseBase(this, _maxMultipartParts)[_maxMultipartParts];
    }
    _classPrivateFieldLooseBase(this, _chunks)[_chunks] = Array(arraySize);
    var _loop = function _loop(offset, j) {
      var end = Math.min(fileSize, offset + chunkSize);

      // Defer data fetching/slicing until we actually need the data, because it's slow if we have a lot of files
      var getData = function getData() {
        var i2 = offset;
        return _classPrivateFieldLooseBase(_this2, _data)[_data].slice(i2, end);
      };
      _classPrivateFieldLooseBase(_this2, _chunks)[_chunks][j] = {
        getData: getData,
        onProgress: _classPrivateFieldLooseBase(_this2, _onPartProgress)[_onPartProgress](j),
        onComplete: _classPrivateFieldLooseBase(_this2, _onPartComplete)[_onPartComplete](j),
        shouldUseMultipart: shouldUseMultipart
      };
      if (_classPrivateFieldLooseBase(_this2, _isRestoring)[_isRestoring]) {
        var size = offset + chunkSize > fileSize ? fileSize - offset : chunkSize;
        // setAsUploaded is called by listPart, to keep up-to-date the
        // quantity of data that is left to actually upload.
        _classPrivateFieldLooseBase(_this2, _chunks)[_chunks][j].setAsUploaded = function () {
          _classPrivateFieldLooseBase(_this2, _chunks)[_chunks][j] = null;
          _classPrivateFieldLooseBase(_this2, _chunkState)[_chunkState][j].uploaded = size;
        };
      }
    };
    for (var offset = 0, j = 0; offset < fileSize; offset += chunkSize, j++) {
      _loop(offset, j);
    }
  } else {
    _classPrivateFieldLooseBase(this, _chunks)[_chunks] = [{
      getData: function getData() {
        return _classPrivateFieldLooseBase(_this2, _data)[_data];
      },
      onProgress: _classPrivateFieldLooseBase(this, _onPartProgress)[_onPartProgress](0),
      onComplete: _classPrivateFieldLooseBase(this, _onPartComplete)[_onPartComplete](0),
      shouldUseMultipart: shouldUseMultipart
    }];
  }
  _classPrivateFieldLooseBase(this, _chunkState)[_chunkState] = _classPrivateFieldLooseBase(this, _chunks)[_chunks].map(function () {
    return {
      uploaded: 0
    };
  });
}
function _createUpload2() {
  this.options.companionComm.uploadFile(_classPrivateFieldLooseBase(this, _file)[_file], _classPrivateFieldLooseBase(this, _chunks)[_chunks], _classPrivateFieldLooseBase(this, _abortController)[_abortController].signal).then(_classPrivateFieldLooseBase(this, _onSuccess)[_onSuccess], _classPrivateFieldLooseBase(this, _onReject)[_onReject]);
  _classPrivateFieldLooseBase(this, _uploadHasStarted)[_uploadHasStarted] = true;
}
function _resumeUpload2() {
  this.options.companionComm.resumeUploadFile(_classPrivateFieldLooseBase(this, _file)[_file], _classPrivateFieldLooseBase(this, _chunks)[_chunks], _classPrivateFieldLooseBase(this, _abortController)[_abortController].signal).then(_classPrivateFieldLooseBase(this, _onSuccess)[_onSuccess], _classPrivateFieldLooseBase(this, _onReject)[_onReject]);
}
function _abortUpload2() {
  var _this3 = this;
  _classPrivateFieldLooseBase(this, _abortController)[_abortController].abort();
  this.options.companionComm.abortFileUpload(_classPrivateFieldLooseBase(this, _file)[_file]).catch(function (err) {
    return _this3.options.log(err);
  });
}
export default MultipartUploader;